<template>
  <div>
    <div :class="$style.voucher" ref="voucher">
      <ul v-if="voucherList.length">
        <li v-for="(item, index) in voucherList" :key="index" :class="[item.status !== 1 ? $style.overdue : '']">
          <div>
            <span :class="$style.name">{{ item.name }}</span>
            <span :class="$style.price">{{ item.type === 1 ? `￥${item.off_money}` : `${item.percent * 10}折` }}</span>
            <span :class="[$style.condition, item.status !== 1 ? $style.overdue : '']" v-if="item.type === 1">满{{ item.condition_money }}可使用</span>
          </div>
          <div :class="$style.effective" v-if="item.status === 1">有效期：{{ moment(item.effective_time).format("YYYY年MM月DD日") }}-{{ moment(item.invalid_time).format("YYYY年MM月DD日") }}</div>
          <div :class="$style.effective" v-if="item.status === 0">已失效</div>
          <div :class="$style.effective" v-if="item.status === 2">已使用</div>
        </li>
      </ul>
      <div v-else :class="$style.empty">
        <img :src="`${$cdnLink}/suspend/fuli/empty.png`" alt="" />
        <p>
          快去<span>【{{ officalAccount }}】</span>领取吧
        </p>
        <p>公众号账号：{{ officalId }}</p>
        <button class="btn" :data-clipboard-text="officalId" @click="buryReport">一键复制打开微信领取</button>
      </div>
    </div>
    <div :class="$style.getMore" @click="getMore" v-if="voucherList.length && jump_mode">
      <span>领取更多</span>
      <img :src="`${$cdnLink}/suspend/qingbao/xiangyou.png`" alt="" />
    </div>
    <Popup v-if="popupVisible" :account="officalAccount" :accountId="officalId" type="gift" text="代金券领不停" @close="popupVisible = false"></Popup>
  </div>
</template>

<script>
import moment from 'moment';
import Popup from '../common/Popup.vue';
import { voucherApi } from '@/api/suspend';
import { mapState } from 'vuex';
import Clipboard from 'clipboard';
import { gameOpenDownloads } from '@/bridge/AppJsBridge'
import { buryReport } from '@/libs/business/account';

export default {
  name: '',
  data() {
    return {
      moment,
      voucherList: [],
      popupVisible: false,
    };
  },
  mounted() {
    this.getVoucherList();
    this.copyInit();
  },
  computed: {
    ...mapState({
      officalAccount: state => state.suspend.account_name,
      officalId: state => state.suspend.account_id,
      jump_mode: state => state.suspend.jump_mode
    })
  },
  methods: {
    buryReport() {
      buryReport('GIFT_CLICK_COPY')
    },
    copyInit() {
      this.clipboard = new Clipboard('.btn');
      this.clipboard.on('success', () => {
        this.$toast('复制成功');
        gameOpenDownloads({
          gameUrl: 'weixin://'
        })
      });
    },
    async getVoucherList() {
      const user_id = this.$getStorage('user_id');
      const appkey = this.$getStorage('appkey');
      const game_version = this.$getStorage('game_version');
      const access_token = this.$getStorage('access_token');

      const r = await voucherApi({ user_id, appkey, game_version, access_token });
      this.voucherList = r.content;
    },
    getMore() {
      this.popupVisible = true;
    },
  },
  beforeDestroy() {
    this.clipboard && this.clipboard.destroy();
  },
  components: {
    Popup,
  },
};
</script>

<style lang="scss" module>
.voucher {
  font-size: 15px;
  height: calc(100% - 30px);
  overflow: auto;
  > ul {
    margin-top: 10px;
    > li {
      width: 296px;
      height: 71px;
      background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/fuli/daijinquan.png') no-repeat;
      background-size: 100% 100%;
      margin: 0 auto 9px;
      color: #ffffff;
      box-sizing: border-box;
      padding: 13px 18px;
      &.overdue {
        background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/fuli/daijinquan3.png') no-repeat;
        background-size: 100% 100%;
      }
      > div:nth-child(1) {
        margin-bottom: 12px;
        > span {
          display: inline-block;
        }
      }
      .name {
        font-size: 12px;
        margin-right: 2px;
      }
      .price {
        font-size: 22px;
        margin-right: 10px;
      }
      .condition {
        width: 81px;
        height: 17px;
        text-align: center;
        background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/fuli/daijinquan2.png') no-repeat;
        background-size: 100% 100%;
        color: #ff5b58;
        font-size: 11px;
        line-height: 17px;
        position: relative;
        bottom: 3px;
        &.overdue {
          filter: grayscale(100%);
          filter: gray;
        }
      }
      .effective {
        font-size: 11px;
      }
    }
  }
  .empty {
    text-align: center;
    margin-top: 40px;
    color: #7a7979;
    font-size: 10px;
    > img {
      width: 98px;
      display: inline-block;
    }
    span {
      color: #ff5b58;
    }
    button {
      background: #ff5b58;
      color: #ffffff;
      border: none;
      width: 150px;
      height: 25px;
      border-radius: 14px;
      margin-top: 13px;
      font-size: 9px;
    }
  }
}
.getMore {
  position: absolute;
  bottom: 0;
  left: 0;
  background: #ffffff;
  width: 100%;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #ff5b58;
  box-shadow: 0px -3px 19px 0px rgba(0, 0, 0, 0.32);
  > img {
    display: inline-block;
    margin-left: 3px;
    width: 12px;
    height: 12px;
  }
}
</style>
